import DockingPlugin from '../plugin/DockingPlugin';
import StickyDockingPlugin from '../plugin/StickyDockingPlugin';
import DockingViewState from '../store/schema/DockingViewState';
import { PluginViewStateAdapter } from 'owa-editor';

export default function createDockingPlugin(adapter: PluginViewStateAdapter<DockingViewState>) {
    return adapter().useStickyDocking
        ? new StickyDockingPlugin(adapter)
        : new DockingPlugin(adapter);
}
